export const TOOLTIP_MODE = {
	INDIVIDUAL: 1,
	COMBINED: 2,
	COMBINED_REVERSE: 3,
	NONE: 4
};



// WEBPACK FOOTER //
// ./utils/panelgraph/constants.js